import { getScopeReadyData } from 'src/state/scope/Scope.types';
import type { AppState } from 'src/reducers';
import { setSelcetedMacroAnchors } from './MacroSummaries.slice';
import { getMappedSummaries } from './MacroSummaries.selector';
import { getScopeObject } from 'src/components/Mfp/MfpScopeSelector/MfpScopeUtils';
import { setMfpMacroSummariesCollapsed } from 'src/state/uipose/UiPose.slice';

export function mapStateToProps(state: AppState, ownProps: { showMinimizableItem?: boolean }) {
  const readyScope = getScopeReadyData(state.mfpScope);

  const currentAnchors = readyScope ? readyScope.currentAnchors : undefined;
  const anchorMembers = readyScope ? getScopeObject(readyScope.mainConfig.memberTrees) : undefined;

  return {
    metrics: getMappedSummaries(state),
    showMinimizableItem: ownProps.showMinimizableItem,
    selectedMacroAnchors: state.macroSummaries.selectedMacroAnchors,
    currentAnchors,
    anchorMembers,
    isMfpMacroSummariesCollapsed: state.uiPose.isMfpMacroSummariesCollapsed,
  };
}

export const mapDispatchToProps = {
  setSelcetedMacroAnchors,
  setMfpMacroSummariesCollapsed,
};
